<template>
  <div class="navbar" :class="{'white-bg': menu_type == 2}" >
    <div class="menu clearfix">
      <div class="logo">
        <a href="/">
          <img v-if="menu_type == 1" src="../../../assets/logo-w.png" alt="乐接活" />
          <img v-if="menu_type == 2" src="../../../assets/logo.png" alt="乐接活" />
          <span  class="text-m" :class="{'text-white': menu_type == 1,'text-666': menu_type == 2}"  >灵活用工全场景服务</span>
        </a>
      </div>

      <div class="m-items">
        <ul>
          <li v-for="(item, index) in menus" :key="index">
            <router-link  class="text-m" v-show="!isAbout" active-class="active" :to="{ path: item.url }" exact >{{item.name}}</router-link>
            <router-link  class="text-m text-white link"  v-show="isAbout && menu_type == 1"  active-class="active1" :to="{ path: item.url }" exact >{{item.name}}</router-link>
            <router-link  class="text-m"  v-show="isAbout && menu_type == 2"  active-class="active" :to="{ path: item.url }" exact >{{item.name}}</router-link>
          </li>
        </ul>
        <div class="login" v-show="!isAbout">
          <button class="text-m text-white" @click="skipTo()">企业登录</button>
        </div>
        <div class="login" v-show="isAbout">
          <button class="text-m" @click="skipTo()" :class="{'white': menu_type == 1, 'text-white': menu_type == 2}">企业登录</button>
        </div>
        <div class="tel" v-if="isAbout">
          <img v-if="menu_type == 2" src="../../../assets/tel-b.png" alt="乐接活" />
          <img v-if="menu_type == 1" src="../../../assets/tel-ww.png" alt="乐接活" />
          <span :class="{'text-blue': menu_type == 2, 'text-white': menu_type == 1}">0512-67903209</span>
        </div>
        <div class="tel" v-if="!isAbout">
          <img src="../../../assets/tel-b.png" alt="乐接活" />
          <span >0512-67903209</span>
        </div>
      </div>
      

    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import store from '../../../store/index';

export default {
  name: "Menu",
  props:['menuType'],
  data: function(){
    return {
      menus: [],
      isAbout: false,
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'menu_type'
    ])
  },
  watch: {
    '$route'(to){
      if(to.fullPath == '/about'){
        this.isAbout = true;
      }else{
        this.isAbout = false;
      }
    }
  },
  
  mounted() {
    let menus = this.getMenus(this.permission_routes)
    this.menus = menus;

    let path = this.$route.fullPath;
    if(path == '/about'){
      this.isAbout = true;
    }else{
      this.isAbout = false;
    }

    console.log('menu_type',this.menu_type);
  },
  methods: {
    getMenus(routes){
      let menus = [];
      routes.forEach(item => {
        if(item.children){
          item.children.forEach((c) =>{
            menus.push({url: c.path ? c.path : '/', name: c.meta.title});
          })
        }
      });
      return menus;
    },
    skipTo(){
      window.open('https://qiye.lejiehuo.com/main/login');
    }
    
  }
};
</script>

<style lang="scss" scoped>
.white-bg{
  background: $white!important;
  box-shadow:0px 4px 16px 2px rgba(43,119,241,0.1);
}
.navbar {
  background: none;
  width: 100%;
  height: 74px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  .menu{
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
    .logo{
      text-align: right;
      padding-left: 5px;
      float: left;
      a{
        display: inline-block;
        width:100%;
        height: 100%;
        line-height: 74px;
        &:hover{
          text-decoration: none;
        }
        img{
          width: 66px;
          height: 36px;
          vertical-align: middle;
        }
        span{
          font-weight:400;
          vertical-align: middle;
          margin-left: 22px;
        }
      }
    }
    .m-items{
      float: right;
      overflow: hidden;
      display: flex;
      ul {
        overflow: hidden;
        margin-left: 280px;

        li {
          float: left;
          padding: 0 20px;
          line-height: 74px;
          a{
            display: inline-block;
            width: 100%;
            height: 100%;
            color: #666;
            &:hover{
              text-decoration: none;
              position: relative;
              color: $blue!important;
                &::after{
                  content: ' ';
                  width: 18px;
                  height: 3px;
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  bottom: 18px;
                  background: $blue!important;
                }
            }
          }
          .link{
            &:hover{
              text-decoration: none;
              position: relative;
              color: $white!important;
              &::after{
                content: ' ';
                width: 18px;
                height: 3px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 18px;
                background: #fff!important;
              }
            }
          }
          
          &:last-child{
            padding-right: 0;
          }
          &:first-child{
            padding-left: 0;
          }
        }
      }
      .login{
        padding: 0 40px;
        line-height: 74px;
        button{
          background:rgba(76,150,254,1);
          box-shadow:0px 6px 8px 0px rgba(42,129,253,0.16);
          border-radius:18px;
          width:108px;
          height:35px;
          border: none;
          &:hover{
            background: #2f85fe;
          }
        }
        .white{
          background: #fff;
          color: rgba(76,150,254,1);
          &:hover{
            background:#e1ecff;
          }
        }
      }
      .tel{
        line-height: 74px;
        img{
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        span{
          font-size: 16px;
          color: #4C96FE;
          vertical-align: middle;
          margin-left: 10px;
        }
      }
    }
    .active{
      color:$blue!important;
      position: relative;
      &::after{
        content: ' ';
        width: 18px;
        height: 3px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 18px;
        background: #4C96FE;
      }
    }
    .active1{
      color:$white!important;
      position: relative;
      &::after{
        content: ' ';
        width: 18px;
        height: 3px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 18px;
        background: #fff;
      }
    }
  }
}
</style>